<template>
    <b-row>
       <b-col cols="12">
            <b-form-group label="Venue ID">
                <b-form-input v-model="shopID" type="text"></b-form-input>
            </b-form-group>

            <b-form-group label="Api Key">
                <b-form-input type="password" v-model="apiKey" placeholder="Enter your API key"></b-form-input>
            </b-form-group>

            <b-form-group label="Menu API Username">
                <b-form-input v-model="menuApiUsername" placeholder="Enter your Menu API username"></b-form-input>
            </b-form-group>

            <b-form-group label="Menu API Password">
                <b-form-input type="password" v-model="menuApiPassword" placeholder="Enter your Menu API password"></b-form-input>
            </b-form-group>

            <b-button variant="primary" @click="save">{{ $t('save') }}</b-button>
       </b-col>

       <b-col cols="12" class="mt-5">
            <b-form-group label="Secret">
                <b-input-group>
                   
                    <b-form-input :value="secret" :type="revealSecret ? 'text' : 'password'"></b-form-input>
                    <b-button @click="revealSecret = !revealSecret" variant="dark">
                        <b-icon :icon="revealSecret ? 'eye' : 'eye-slash'" />
                    </b-button>

                </b-input-group>
            </b-form-group>

            <b-form-group label="Webhook"> 
                <b-form-input :value="webhook" disabled type="text"></b-form-input>
            </b-form-group>

            <p class="text-muted">{{ $t('integrations.deliveries.wolt.integration_disclaimer') }}</p>
       </b-col>
    </b-row>
</template>

<script>
export default {
    name: 'Settings',
    components: {},

    data: function () {
        return {
            user: null,
            apiKey: null,
            shopID: null,
            secret: null,
            revealSecret: false,
            webhook: null,
        }
    },

    methods: {
        async save() {
            await this.$integrationApi.post(`/karadjordje/deliveries/users/${this.user.id}/providers/wolt`, {
                api_key: this.apiKey,
                shop_id: this.shopID,
                user_name: this.menuApiUsername,
                password: this.menuApiPassword,
            })
        }
    },

    computed: {},

    mounted() {
        this.$integrationApi.get(`/karadjordje/deliveries/users/settings`).then(({data}) => {
            this.user = data.user
            this.webhook = data.webhook

            const { providers } = this.user
            const { deliveries } = providers || {}
            const { wolt } = deliveries || {}
            if (wolt) {
                this.apiKey = wolt.api_key || null
                const [ shop = {} ] = wolt.shops || []
                this.shopID = shop.shop_id || null
                this.secret = wolt.client_secret || null
                this.menuApiUsername = wolt.user_name || null
                this.menuApiPassword = wolt.password || null
            }
        })
    }
}
</script>